// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2ko_q","item":"PaymentsMobile_item__VSy0x","label":"PaymentsMobile_label__28TQq","amount":"PaymentsMobile_amount__3hIb8"};